function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import PropTypes from "prop-types";
import * as stylex from "@stylexjs/stylex";
/**
 * @typedef Object FlexShape
 * @property boolean isHorizontal
 */

/**
 * @param props FlexShape
 * @returns {JSX.Element}
 * @constructor
 */
export default function Flex(props) {
  var _props$classNames, _props$gap, _props$alignItems, _props$grow, _props$wrap;
  return /*#__PURE__*/React.createElement("div", _extends({
    id: props.id,
    className: (_props$classNames = props.classNames) === null || _props$classNames === void 0 ? void 0 : _props$classNames.join(' '),
    style: _objectSpread({
      display: "flex",
      gap: "".concat((_props$gap = props.gap) !== null && _props$gap !== void 0 ? _props$gap : 0, "px"),
      flexDirection: props.isHorizontal === void 0 || props.isHorizontal ? 'row' : 'column',
      alignItems: (_props$alignItems = props.alignItems) !== null && _props$alignItems !== void 0 ? _props$alignItems : "center",
      flexGrow: (_props$grow = props.grow) !== null && _props$grow !== void 0 ? _props$grow : 0,
      flexWrap: ((_props$wrap = props.wrap) !== null && _props$wrap !== void 0 ? _props$wrap : false) ? 'wrap' : 'nowrap'
    }, props.style)
  }, stylex.props(props.stylex)), props.children);
}
Flex.propTypes = {
  gap: PropTypes.number,
  isHorizontal: PropTypes.bool,
  alignItems: PropTypes.string,
  classNames: PropTypes.array,
  id: PropTypes.string,
  wrap: PropTypes.bool,
  grow: PropTypes.number
};